'use client';

import { ReturnAttribution } from '@/components/return-attribution';

import type { InvestorAttribution } from '../types/api';

interface PortfolioReturnAttributionProps {
  attribution?: InvestorAttribution | null;
  isLoading?: boolean;
  isError?: boolean;
}

/**
 * The investor's window return split by held vault. Every line is measured
 * on this route (a vault the series cannot value is excluded from both
 * sides and disclosed), so the residual is only the compounding gap and
 * rounding. The yield, price, fees and execution split waits on its own
 * contract.
 */
export function PortfolioReturnAttribution({
  attribution,
  isLoading = false,
  isError = false
}: PortfolioReturnAttributionProps) {
  return (
    <ReturnAttribution
      attribution={
        attribution == null
          ? attribution
          : {
              lines: attribution.byPosition.map((position) => ({
                id: position.vaultAddress,
                label: position.name,
                contributionBps: position.contributionBps
              })),
              residualBps: attribution.residualBps,
              totalBps: attribution.portfolioReturnBps
            }
      }
      isLoading={isLoading}
      isError={isError}
      // The parse boundary allows the basis point of rounding each line can
      // carry, so the heading no longer promises "exactly".
      summary="How each vault added to the window return"
      residualLabel="Compounding and rounding"
      totalLabel="Window return"
      unavailableMessage="Attribution appears once this window has enough daily returns."
      errorMessage="We could not load attribution. Retry from the banner above."
      footnote="The yield, price, fees, and execution split is waiting on data."
    />
  );
}
